import { Instance } from 'mobx-state-tree'
import { MembershipModelBase } from './MembershipModel.base'

/* The TypeScript type of an instance of MembershipModel */
export interface MembershipModelType extends Instance<typeof MembershipModel.Type> {}

/* A graphql query fragment builders for MembershipModel */
export { selectFromMembership, membershipModelPrimitives, MembershipModelSelector } from './MembershipModel.base'

/**
 * MembershipModel
 */
export const MembershipModel = MembershipModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
